export default "__VITE_ASSET__ChHauCyq__"